import { render, staticRenderFns } from "./notificationIcon.vue?vue&type=template&id=340e7788&"
import script from "./notificationIcon.vue?vue&type=script&lang=js&"
export * from "./notificationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports